module.exports = __webpack_public_path__ + "img/BPPMP8.89a4251e.png";